/** Endpoints da camada geo para push (/geo/v1/push/*). Envio manual de mensagem. */

const BASE = '/geo/v1';

async function req<T>(url: string, init?: RequestInit): Promise<T> {
  const r = await fetch(url, {
    credentials: 'include',
    headers: init?.body ? { 'Content-Type': 'application/json' } : undefined,
    ...init,
  });
  if (!r.ok) {
    let detail = `${r.status}`;
    try {
      const j = await r.json();
      if (j?.detail) detail = j.detail;
    } catch {
      /* ignore */
    }
    throw new Error(detail);
  }
  if (r.status === 204) return undefined as T;
  return r.json() as Promise<T>;
}

export interface PushSendResult {
  sent: number;
  failed: number;
  tokens: number;
}

export const pushApi = {
  /** Envia mensagem push (título/corpo) aos usuários. Só admin/revenda. */
  send: (userIds: number[], title: string, body: string) =>
    req<PushSendResult>(`${BASE}/push/send`, { method: 'POST', body: JSON.stringify({ userIds, title, body }) }),
};
